export default "__VITE_ASSET__dSqTkpsI__"